export default {
  name: 'returnable',

  data: () => ({
    originalValue: null
  }),

  props: {
    returnValue: null
  },

  watch: {
    isActive (val) {
      if (val) {
        this.originalValue = this.returnValue
      } else {
        this.$emit('update:returnValue', this.originalValue)
      }
    }
  },

  methods: {
    save (value) {
      this.originalValue = value
      this.isActive = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/returnable.js